//@flow
import React from 'react'
import './styles.css'

type Props = {
  title: string
}

export default ({title}: Props) => {

  return(
    <fb className="userProfileHeadlineMain">
      {title}
    </fb>
  )
}



// WEBPACK FOOTER //
// ./src/containers/app/userProfile/components/headline/index.js